import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from '@/plugins/vuetify';

async function main() {
    // create & mount the Vue App instance
    const app = createApp(App);

    app.use(vuetify);

    app.use(store);

    app.use(router);

    app.mount('#app');
}

main();
